
export enum toolType {
    InvalidTool = -1,
    Ruler = 1,
    DepthGuage=2,
    UT=3,
    Calipers=4,
    KeeperOrientation=5,
    DriveLugsEngaged=6,
    YESorNO=7,
    Observation=8,
    Eval=9,
    PassorFail=10,
    Template = 11,
    PitchGauge = 12,
    ConditionAssessment=13
}

export enum toolTypeYesNo {
    No = 0,
    Yes = 1
}

export enum toolTypePassFail {
    Fail = 0,
    Pass = 1
}

export enum componentTypes {
  Link = 230,
  Bushing = 231,
  Shoe = 232,
  Idler = 233,
  CarrierRoller = 234,
  TrackRoller = 235,
  Sprocket = 236,
  Guard = 237,
  TrackElongation = 240
}

export enum ScreenCode {
  ManageEquipment = 'ManageEquipment',
  Dashboard = 'Dashboard',
  Inspection = 'Inspection',
  ComponentOverviewDashboard = 'ComponentOverview',
  TabularInspectionHx = 'TabularInspectionHx',
}

export enum ManageEquipmentColumn {
  CMU = 1,
  ResLife100 = 2,
  ResLife120 = 3,
  DOC = 4,
  ResDOC100 = 5,
  ResDOC120 = 6,
  Reading = 7,
  Worn0Percent = 8,
  Worn100Percent = 9,
  WorkOrder = 10,
  Brand = 11,
  BudgetLife = 12,
  BushTurned = 13,
  ProjectedLife100 = 14,
  ProjectedLife120 = 15,
  Difference = 16,
  PurchaseCost = 17,
  RepairCost = 18,
  InstallDate = 19,
  ActualWearRate = 21,
  BudgetWearRate = 20,
  ReplacementDate = 22,
  PropelBudget = 23
}

export enum ComponentOverviewColumns {
    Serial = 1,
    Unit = 2,
    AdditionalUnit = 3,
    Model = 4,
    Site = 5,
    Inspector = 6,
    CurrentSMUHourmeter = 7,
    LastInspectionDateSMUHourmeter = 8,
    DaysSinceLastInspection = 9,
    NextInspectionDateSMUHourmeter = 10,
    FrameSerialNumbers = 11,
    TrackFrameBudgetLife = 12,
    HoursOnTrackFrames = 13,
    TrackFrameDateCO = 14,
    TrackFrameSMUCO = 15,
    EQBarLife = 16,
    HoursOnLink = 17,
    Link = 18,
    TrackElongation = 19,
    Bush = 20,
    BushTurnedBudget = 21,
    BushTurned = 22,
    Shoe = 23,
    FrontIdler = 24,
    RearIdler = 25,
    Sprocket = 26,
    CarrierRollerAVG = 27,
    TrackRollerAVG = 28,
    TrackRollerWorst = 29,
    OutstandingActions = 30
}

export enum PercentWornCalculationMethod {
  WorstWorn = 1,
  AverageComponents = 2
}

export enum ScreenCode {
  WC = 1,
  WF = 2,
  WI = 3,
  ME = 14,
  IP = 15,
}


export enum ConfigType {
  Fleet = 'Fleet_Report',
  Alert = 'Alerts_Report',
}

export enum DashBoardModule {
  UC = 1,
  GET = 2,
  DFI =3
}

export enum ModuleType {
  GET = 'GET',
  UC = 'UC',
  INVENTORY = 'INVENTORY'
}

export enum EquipmentFamily {
  ITC = 160,       // Integrated Tool Carrier
  TRAC = 163,      // Crawler Tractor
  COM = 166,       // Compactor
  DOZ = 167,       // Dozer - Elevated Sprocket
  EXC = 169,       // Excavator
  FP = 170,        // Forestry Product
  DRI = 172,       // Drill Rig
  MEX = 177,       // Hydraulic Shovel/Excavator
  PIP = 184,       // Pipelayer
  PP = 185,        // Paving Product
  Unknown = 196,   // Unknown
  DOZO = 197,      // Dozer - Oval Config
  CH = 198,        // Cane Harvesters
  LOAD = 199,      // Underground Loader
  OHT = 200,       // Off Highway Truck
  DUMP = 201,      // Dump Body
  ADT = 202,       // Articulated Dump Truck
  RSH = 203,       // Rope Shovel
  WT = 204,        // Wind Turbine
  CSH = 205,       // Powerscreen Crusher
  PT = 206,        // Paver Truck
  ACM = 207,       // Asphalt Cold Milling
  CC = 208,        // Crawler Crane
  DRAG = 209,      // Dragline
  WL = 210,        // Wheel Loader
  QDT = 211,       // Quadtrac
  ERS = 212        // Electric Rope Shovel
}

export enum InspectionApiType {
  BMA = 0,
  CrackMap = 1,
  EquipmentInspection = 2,
  EquipmentCurrentCondition = 3,
  Detailed = 4
}
